import createCRUDObservable from 'redux-observable-crud'
import { combineEpics } from 'redux-observable'
import { Observable } from 'rxjs'

import ActiveCheckinsActions, { ActiveCheckinsRedux, ActiveCheckinsTypes } from '../Redux/ActiveCheckinsRedux'
import { notificationFail } from '../Redux/NotificationActions'

const activeCheckinsCrudObservable = createCRUDObservable({
  mainRedux: ActiveCheckinsRedux,
  reduxPath: 'activeCheckins',
})

const activeCheckinsExcelEpic = (action$, store, { Api }) =>
  action$.ofType(ActiveCheckinsTypes.ActiveCheckinsExcelRequest)
    .mergeMap(() => (
      Observable
        .fromPromise(Api.activeCheckins.getActiveCheckinsExcel()
          .then(response => response)
          .catch(error => error))
        .flatMap((response) => {
          const { status } = response
          if (!(status >= 200 && status < 300)) {
            return [notificationFail('Falló la descarga')]
          }
          const file = response.headers['content-disposition']
          const index = file.indexOf('=')
          const fileName = file.substring(index + 1, file.length)
          const url = window.URL.createObjectURL(new Blob([response.data]))
          const link = document.createElement('a')
          link.href = url
          link.setAttribute('download', fileName)
          document.body.appendChild(link)
          link.click()
          return [
            ActiveCheckinsActions.ActiveCheckinsExcelSuccess(),
          ]
        })
    ))

export const activeCheckinsObservers = Object.assign({}, activeCheckinsCrudObservable.observers, {})

export const activeCheckinsEpic = combineEpics(
  activeCheckinsCrudObservable.epic,
  activeCheckinsExcelEpic,
)



// WEBPACK FOOTER //
// ./src/Data/Observables/ActiveCheckinsObservable.js